// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3_Kmq","content":"styles_content__h2dVH","intro":"styles_intro__2fWzA"};